import { CODE } from 'domains/product-attribute/constants'
import ProductAttributeService from 'domains/product-attribute/services'
import { useFormikContext } from 'formik'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import ProductAttributeDatatypeFields from './product-attribute-datatype-fields'
import ProductAttributeSelectField from 'domains/product-attribute/molecules/select-field'


const propTypes = {
  prefixName : PropTypes.string,
  attributes : PropTypes.arrayOf(PropTypes.object)
}

/**
 * Render dynamic product attribute field by given attributes objects
 * @param {string} prefixName - prefix Formik name value. used for Field array
 * @param {array} attributes - product attribute array
 */
const ProductAttributeDynamicFields = ({
  prefixName,
  attributes
}) => {
  const {
    initialValues: {
      name: initialName
    },
    values: {
      brand,
      category,
      colour,
      pattern
    },
    setFieldValue
  } = useFormikContext()

  const attributeKeysWithOrder       = Object.keys(attributes).map( (key) => ({ order: attributes[key].order, code: key }))
  const sortedAttributeKeysWithOrder = attributeKeysWithOrder.sort((a, b) => (a.order > b.order) ? 1 : -1)

  useEffect(() => {
    /**
     * Auto generated name value. It will generate new name as along as these values has chage and not empty
     * - brand
     * - colour
     * - pattern
     * - category
     *
     * format: <brand> <colour> <pattern> <categroy>
     */
    const isProductNameGeneratable = brand && category && colour?.length > 0

    if (isProductNameGeneratable)
    {
      // the order represententing order in name value
      const selectedOptionsMap = {
        [CODE.BRAND]    : brand,
        [CODE.COLOUR]   : colour,
        [CODE.PATTERN]  : pattern,  // * optional attribute
        [CODE.CATEGORY] : category
      }

      const generatedName = ProductAttributeService.autoGeneratedName(selectedOptionsMap)
      setFieldValue(CODE.NAME, generatedName)
    }

  }, [ brand, category, colour, pattern, setFieldValue ])

  useEffect(() => {
    /**
     * Auto generated name might overwrite current name on edit process
     * So, we force to update name to be iniital value
     */
    if (initialName !== '') setFieldValue(CODE.NAME, initialName)
  }, [ initialName, setFieldValue ])


  return (
    <>
      {
        sortedAttributeKeysWithOrder
          .map((obj, i) => {
            const {
              code,
              label,
              unit,
              datatype,
              is_curation_field,
              curation_field_required,
              curation_text,
              has_reference_table,
              allow_multiple_values
            } = attributes[obj.code]

            let name = code
            if (prefixName) name = `${prefixName}.${name}`

            // don't show the field
            if (!is_curation_field) return (<> </>)

            // map to specific fields
            //  - 1. has reference table
            //  - 2. datatype
            if (has_reference_table) {
              return (
                <ProductAttributeSelectField
                  key={ `${code}-attribute-select-field` }
                  code={ code }
                  name={ name }
                  label={ label }
                  isCuration={ true }
                  isMulti={ allow_multiple_values }
                  required={ curation_field_required }
                  formText={ curation_text }
                />
              )
            }
            else {
              return (
                <ProductAttributeDatatypeFields
                  key={ `${i}-fields` }
                  name={ name }
                  code={ code }
                  label={ label }
                  unit={ unit }
                  required={ curation_field_required }
                  datatype={ datatype }
                  formText={ curation_text }
                />
              )
            }
          })
      }
    </>
  )
}

ProductAttributeDynamicFields.propTypes = propTypes

export default ProductAttributeDynamicFields
